import { Channel } from '@nemuru-eng/js-api-client';
import { SWRConfig } from 'swr';

import { ConfigurationEditWrapper } from '@/components/modules/ChannelDetail/ChannelDetails/components/Configuration/components/ConfigurationEditWrapper';
import { ConfigurationForm } from '@/components/modules/ChannelDetail/ChannelDetails/components/Configuration/components/ConfigurationForm';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';

export const Configuration = ({
  currentChannel,
  editModeAllowed,
  merchantId,
}: {
  currentChannel: Channel;
  editModeAllowed?: boolean;
  merchantId: string;
}) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const toggleEditModeDialog = editModeAllowed && currentChannel ? toggleDialog : undefined;

  return (
    <SubSectionWrapper title={'CONFIGURATION'} toggleEditModeDialog={toggleEditModeDialog}>
      {!currentChannel ? (
        <PendingDataWarning />
      ) : (
        <>
          <ConfigurationForm currentChannel={currentChannel} />
          <SWRConfig value={{ revalidateOnMount: false }}>
            <ConfigurationEditWrapper
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              currentChannel={currentChannel}
              merchantId={merchantId}
            />
          </SWRConfig>
        </>
      )}
    </SubSectionWrapper>
  );
};
